import { useState } from 'react';

const BenefitsSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const benefits = [
    {
      title: "Reduced Claim Denials",
      content: "Our expert team ensures accurate coding and documentation, significantly reducing claim denials and improving your revenue cycle efficiency."
    },
    {
      title: "Faster Payment",
      content: "With streamlined processes and timely claim submissions, we accelerate your payment cycles, improving your practice's cash flow."
    },
    {
      title: "Cost Savings",
      content: "Outsourcing eliminates the need for in-house billing staff, training costs, and expensive billing software, reducing your operational expenses."
    },
    {
      title: "Consistent AR Follow-Up",
      content: "Our dedicated team provides consistent accounts receivable follow-up, ensuring no claims fall through the cracks and maximizing collections."
    },
    {
      title: "HIPAA Compliant Medical Billing",
      content: "We maintain strict HIPAA compliance standards, ensuring your patient data is secure and your practice meets all regulatory requirements."
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-4">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-blue-500">Benefits of Outsourcing</span>{' '}
            <span className="text-gray-900">Medical Billing to iSolve RCM</span>
          </h2>
          <p className="text-gray-600 text-base lg:text-lg max-w-5xl mx-auto leading-relaxed">
            As a top medical billing company, we handle financial tasks so your practice runs more effectively. Proper claim handling and timely 
            payments reduce stress for your staff. We allow you to focus on patient care while ensuring steady revenue.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Side - Accordion */}
          <div className="space-y-6">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-100 transition-colors"
                >
                  <span className="text-xl font-bold text-gray-700">{benefit.title}</span>
                  <svg 
                    className={`w-8 h-8 text-gray-600 transition-transform duration-300 flex-shrink-0 ml-4 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-48' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 pb-6 text-gray-600 leading-relaxed">
                    {benefit.content}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side - Image */}
          <div className="flex items-center justify-center">
            <img 
              src="/benefits.jpg" 
              alt="Benefits of Outsourcing Medical Billing" 
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
